<template>
  <div class="container">
      <div class="top">
        <part3 />
      </div>
      <div class="bottom">
        <part4/>
      </div>
  </div>
</template>

<script>
import part3 from './part3.vue'
import part4 from './part4.vue'
// import { indexLeft } from '@/api/indexLeft';
// import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      // 用户指标
      //标题
      // userIndicatorsTitle:{
      //   CHN:'用户指标',
      //   ENG:'User indicators'
      // },
      // //展示数据
      // userIndicatorsList:[{
      //   counts:0,
      //   text:"入网用户数"
      // },{
      //   counts:0,
      //   text:"注册用户数"
      // },{
      //   counts:0,
      //   text:"本月新增入网司机"
      // },{
      //   counts:0,
      //   text:"本月换电活跃司机"
      // }],
      // //展示数据
      // carIndicatorsList:[{
      //   counts:0,
      //   text:"换电车辆数"
      // },{
      //   counts:0,
      //   text:"单车日均换电次数"
      // },{
      //   counts:0,
      //   text:"本月新增车辆数"
      // },{
      //   counts:0,
      //   text:"单车日均换电里程"
      // }],
      // //用户指标
      // selectUserTarget:{},
    };
  },
  components: {
    part3,
    part4
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
    
  },
  methods: {
    // 刷新接口需要每个子组件封装一个getData();
//     getData(data){
//       this.yonghuzhibiao(data);
//       this.benyueyonghu(data);
//       this.getCarTarget(data);
//     },
//     //数据接口
// 		yonghuzhibiao(data={}){
//       let _this = this;
// 			let params = {};
// 			if(data){
// 				// TiDB-省市区-用户指标
// 				params = {
// 					"enCode":"TiDB-shengshiqu-yonghuzhibiao",
//     			"@province":data.province||data.city||data.district
// 				}
// 			}else {
// 				params = {
// 					"enCode":"TiDB-quanguo-yonghuzhibiao"// TiDB-全国-用户指标
// 				}
// 			}
//       dataInterface
//         .dataFaceApi(params)
//         .then((res) => {
//           if(!res) return;
//             res = res[0];
//             _this.$set(this.userIndicatorsList,0,{
//               counts:res.AccessUser||0,
//               text:"累计入网用户数"
//             })
//             _this.$set(this.userIndicatorsList,1,{
//               counts:res.RegisterUser||0,
//               text:"累计注册用户数"
//             })
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     },
//     //本月换电活跃用户
//     benyueyonghu(data={}){
//       let _this = this;
// 			let params = {};
// 			if(data){
// 				//省市区
// 				params = {
// 					"enCode":"TiDB-shengshiqu-benyueyonghu",
//     			"@province":data.province||data.city||data.district
// 				}
// 			}else {
// 				params = {
// 					"enCode":"TiDB-quanguo-benyueyonghu"//TiDB-全国-本月用户
// 				}
// 			}
//       dataInterface
//         .dataFaceApi(params)
//         .then((res) => {
//           if(!res) return;
//           res = res[0];
//           console.log(res);
//           _this.$set(this.userIndicatorsList,2,{
//             counts:res.NewUser,
//             text:"本月新增入网司机"
//           })
//           _this.$set(this.userIndicatorsList,3,{
//             counts:res['MonthlyActiveUsers']||0,
//             text:"本月换电活跃司机"
//           })
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     },
//     getCarTarget(data={}){
//       let _this = this;
//       let params = {};
//       if(data){
//         //省市区
//         params = {
//           "enCode":"TiDB-shengshiqu-cheliangzhibiao",
//           "@province":data.province||data.city||data.district
//         }
//       }else {
//         params = {
//           "enCode":"TiDB-quanguo-cheliangzhibiao"//全国
//         }
//       }
//       dataInterface
//         .dataFaceApi(params)
//         .then((res) => {
//           if(!res) return;
//           res = res[0];
//           _this.carIndicatorsList = [{
//             counts:res.changePowerVehicleNum||0,
//             text:"本月换电车辆数"
//           },{
//             counts:res['changePowerNum']||0,
//             text:"单车日均换电次数"
//           },{
//             counts:res['addVehicleNum']||0,
//             text:"本月新增车辆数"
//           },{
//             counts:res['changePowerCourse']||0,
//             text:"单车日均换电里程"
//           }];
//         })
//         .catch((err) => {
//           console.log(err);
//         });
//     }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  .top{
    width:100%;
    height:96.5%;
    display: flex;
    flex-direction: row;
    margin-bottom:50px;
  }
  .bottom{
	margin-top:28px;
    width: 100%;
    height: 100%;
    display: flex;
  }
}
</style>